// VNEC v9 — pages/admin.js
// Admin panel: Table data management + User role management + Danh mục CRUD
import { supabase, getCurrentUser, rpc } from '../lib/supabase.js';
import { formatVND } from '../lib/forms.js';
import { ok, err } from '../components/toast.js';

const TABLES = [
  { id:'hop_dong',  label:'Hợp đồng',   cols:['ma_hd','nha_thau','thanh_tien','trang_thai','created_by'] },
  { id:'chi_phi',   label:'Chi phí',    cols:['so_ct','ma_hd','dot','ten_cp','tong_tt','trang_thai','created_by'] },
  { id:'pyctt',     label:'Phiếu YCTT', cols:['so_pyctt','loai_pyc','ma_hd','so_tien','chi_trong_ky','trang_thai','created_by'] },
  { id:'doanh_so',  label:'Doanh số',   cols:['ma_doanh_so','ky','ma_hd_goc','gia_tri','created_by'] },
  { id:'ngan_sach', label:'Ngân sách',  cols:['ma_ngan_sach','nam','loai_cp','gia_tri','ngan_sach_kh','created_by'] }
];
const DANH_MUC_TABLES = [
  { id:'ifrs_rules',   label:'Loại chi phí (IFRS rules)', cols:['loai_cp','default_phan_loai','locked','note'] },
  { id:'dm_phan_loai', label:'Phân loại HĐ', cols:['phan_loai','mo_ta'] },
  { id:'dm_hinh_thuc', label:'Hình thức HĐ', cols:['hinh_thuc','mo_ta'] },
  { id:'dm_ho_so',     label:'Mã hồ sơ',     cols:['ma_ho_so','mo_ta','nha_thau'] },
  { id:'vat_tu_catalog', label:'Vật tư',     cols:['ma_vat_tu','ten_vat_tu','don_vi','nhom'] }
];

let _state = { tab: 'tables', currentTable: 'hop_dong', showDeleted: false, user: null };

export function renderAdmin() {
  window.__pageInit = initAdmin;
  return `
    <div class="admin-wrap">
      <div class="page-hd">
        <h2>Admin Panel</h2>
        <button class="btn btn-ghost btn-sm" id="ad-refresh">⟳</button>
      </div>
      <div class="tabs" id="ad-tabs">
        <button class="tab active" data-tab="tables">📁 Dữ liệu</button>
        <button class="tab" data-tab="users">👥 Người dùng</button>
        <button class="tab" data-tab="access">🔐 Phân quyền dự án</button>
        <button class="tab" data-tab="log">📜 Lịch sử cấp quyền</button>
        <button class="tab" data-tab="danhmuc">📋 Danh mục</button>
      </div>
      <div id="ad-content"></div>
    </div>`;
}

async function initAdmin() {
  _state.user = await getCurrentUser();
  if (_state.user.role !== 'admin') {
    document.getElementById('ad-content').innerHTML = '<div class="error-box">Chỉ admin mới truy cập được.</div>';
    return;
  }
  document.getElementById('ad-refresh').addEventListener('click', () => renderTab());
  document.querySelectorAll('#ad-tabs .tab').forEach(btn => {
    btn.addEventListener('click', () => switchTab(btn.dataset.tab));
  });
  renderTab();
}

function switchTab(tab) {
  _state.tab = tab;
  document.querySelectorAll('#ad-tabs .tab').forEach(b => b.classList.toggle('active', b.dataset.tab === tab));
  renderTab();
}

function renderTab() {
  if (_state.tab === 'tables') renderTablesTab();
  else if (_state.tab === 'users') renderUsersTab();
  else if (_state.tab === 'access') renderAccessTab();
  else if (_state.tab === 'log') renderAccessLogTab();
  else if (_state.tab === 'danhmuc') renderDanhMucTab();
}

// ── Tab: Phân quyền dự án ──
async function renderAccessTab() {
  const content = document.getElementById('ad-content');
  content.innerHTML = `
    <div class="card" style="margin-bottom:12px">
      <h3 style="margin:0 0 10px">Ma trận phân quyền user × dự án</h3>
      <p class="muted small" style="margin:0">Check ✓ để cấp quyền, bỏ check để thu hồi. Chỉ <b>data_entry</b> và <b>viewer</b> cần được phân quyền (admin/approver/bod thấy tất cả dự án).</p>
    </div>
    <div id="access-matrix-wrap"><div class="loading">Đang tải ma trận...</div></div>`;

  try {
    const [accessRows, users, projects] = await Promise.all([
      rpc('admin_list_project_access'),
      rpc('admin_list_users'),
      supabase.from('du_an').select('ma_da, ten_da').eq('trang_thai','active').is('deleted_at',null).order('ma_da').then(r => r.data || [])
    ]);

    // Filter chỉ data_entry/viewer
    const rawUsers = users || [];
    const showUsers = rawUsers.filter(u => u.role === 'data_entry' || u.role === 'viewer');

    if (!showUsers.length) {
      document.getElementById('access-matrix-wrap').innerHTML = '<p class="muted center" style="padding:30px">Chưa có user nào với role data_entry hoặc viewer.</p>';
      return;
    }
    if (!projects.length) {
      document.getElementById('access-matrix-wrap').innerHTML = '<p class="muted center" style="padding:30px">Chưa có dự án nào.</p>';
      return;
    }

    // Build access lookup: { userId: { ma_da: {is_default} } }
    const accessMap = {};
    (accessRows || []).forEach(r => {
      if (!r.ma_da) return;
      if (!accessMap[r.user_id]) accessMap[r.user_id] = {};
      accessMap[r.user_id][r.ma_da] = { is_default: r.is_default };
    });

    let html = '<div class="access-matrix"><table><thead><tr><th class="user-col">User</th>';
    projects.forEach(p => {
      html += `<th title="${escH(p.ten_da || '')}">${escH(p.ma_da)}</th>`;
    });
    html += '</tr></thead><tbody>';
    showUsers.forEach(u => {
      html += `<tr><td class="user-cell">
        <div>${escH(u.full_name || u.email)}</div>
        <div style="font-size:10px;color:#888;font-weight:400">${escH(u.email)} · ${u.role}</div>
      </td>`;
      projects.forEach(p => {
        const has = !!(accessMap[u.id] && accessMap[u.id][p.ma_da]);
        const isDef = has && accessMap[u.id][p.ma_da].is_default;
        html += `<td ${isDef ? 'class="default-cell"' : ''}>
          <input type="checkbox" class="access-cb" ${has ? 'checked' : ''}
            data-user="${u.id}" data-ma="${escH(p.ma_da)}"
            title="${isDef ? 'Dự án mặc định (⭐)' : ''}">
        </td>`;
      });
      html += '</tr>';
    });
    html += '</tbody></table></div>';

    document.getElementById('access-matrix-wrap').innerHTML = html;

    // Wire checkboxes
    document.querySelectorAll('.access-cb').forEach(cb => {
      cb.addEventListener('change', async () => {
        const userId = cb.dataset.user;
        const maDa = cb.dataset.ma;
        cb.disabled = true;
        try {
          if (cb.checked) {
            await rpc('admin_grant_project_access', { p_user_id: userId, p_ma_da: maDa, p_is_default: false });
            ok(`Cấp quyền ${maDa} cho user`);
          } else {
            await rpc('admin_revoke_project_access', { p_user_id: userId, p_ma_da: maDa });
            ok(`Thu hồi quyền ${maDa}`);
          }
        } catch (e) {
          err('Lỗi: ' + e.message);
          cb.checked = !cb.checked;
        } finally {
          cb.disabled = false;
        }
      });
    });
  } catch (e) {
    document.getElementById('access-matrix-wrap').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

// ── Tab: Audit log ──
async function renderAccessLogTab() {
  const content = document.getElementById('ad-content');
  content.innerHTML = `
    <div class="card" style="margin-bottom:12px">
      <h3 style="margin:0">📜 Lịch sử cấp/thu hồi quyền dự án</h3>
    </div>
    <div id="log-wrap"><div class="loading">Đang tải...</div></div>`;
  try {
    const rows = await rpc('admin_get_access_log', { p_limit: 500 });
    if (!rows || !rows.length) {
      document.getElementById('log-wrap').innerHTML = '<p class="muted center" style="padding:30px">Chưa có lịch sử.</p>';
      return;
    }
    const fmtDate = (s) => { try { return new Date(s).toLocaleString('vi-VN'); } catch(e){return s;} };
    const actionLabel = { grant: '✅ Cấp quyền', revoke: '❌ Thu hồi', set_default: '⭐ Đặt mặc định', bulk_grant: '📦 Cấp hàng loạt' };
    let html = '<table class="tbl"><thead><tr><th>Thời gian</th><th>User</th><th>Dự án</th><th>Hành động</th><th>Bởi</th><th>Ghi chú</th></tr></thead><tbody>';
    rows.forEach(r => {
      html += `<tr>
        <td class="small">${fmtDate(r.at)}</td>
        <td class="small">${escH(r.user_email || r.user_id.slice(0,8))}</td>
        <td><b>${escH(r.ma_da)}</b></td>
        <td>${actionLabel[r.action] || r.action}</td>
        <td class="small">${escH(r.by_email || '—')}</td>
        <td class="small muted">${escH(r.notes || '')}</td>
      </tr>`;
    });
    html += '</tbody></table>';
    document.getElementById('log-wrap').innerHTML = html;
  } catch (e) {
    document.getElementById('log-wrap').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

// ═══════════════ TAB 1: TABLES ═══════════════
async function renderTablesTab() {
  const content = document.getElementById('ad-content');
  content.innerHTML = `
    <div class="ad-toolbar">
      <select class="inp" id="tbl-select">${TABLES.map(t => `<option value="${t.id}"${_state.currentTable===t.id?' selected':''}>${t.label}</option>`).join('')}</select>
      <label class="chk"><input type="checkbox" id="chk-deleted" ${_state.showDeleted?'checked':''}> Hiện bản ghi đã xóa</label>
    </div>
    <div id="tbl-data" class="crud-table-wrap"><div class="loading">Đang tải…</div></div>`;

  document.getElementById('tbl-select').addEventListener('change', e => { _state.currentTable = e.target.value; loadTableData(); });
  document.getElementById('chk-deleted').addEventListener('change', e => { _state.showDeleted = e.target.checked; loadTableData(); });
  loadTableData();
}

async function loadTableData() {
  const def = TABLES.find(t => t.id === _state.currentTable);
  try {
    let q = supabase.from(_state.currentTable).select('*').order('created_at', { ascending: false }).limit(200);
    if (!_state.showDeleted) q = q.is('deleted_at', null);
    const { data, error } = await q;
    if (error) throw error;
    renderTableData(def, data || []);
  } catch (e) {
    document.getElementById('tbl-data').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

function renderTableData(def, rows) {
  const wrap = document.getElementById('tbl-data');
  if (!rows.length) { wrap.innerHTML = '<div class="empty">Không có dữ liệu</div>'; return; }
  let html = `<div class="muted" style="margin-bottom:8px">Hiển thị ${rows.length} bản ghi (tối đa 200)</div>`;
  html += '<table class="tbl"><thead><tr>';
  def.cols.forEach(c => html += `<th>${c}</th>`);
  html += '<th class="c">TT</th><th class="c">Thao tác</th></tr></thead><tbody>';
  rows.forEach(r => {
    html += `<tr${r.deleted_at?' class="row-deleted"':''}>`;
    def.cols.forEach(c => {
      const v = r[c];
      const disp = (c.includes('tien') || c.includes('gia_tri') || c.includes('ngan_sach') || c === 'chi_trong_ky') ? formatVND(v) : (v ?? '');
      html += `<td>${escH(disp)}</td>`;
    });
    html += `<td class="c">${r.deleted_at ? '<span class="badge-st badge-rejected">Đã xóa</span>' : '<span class="badge-st badge-approved">OK</span>'}</td>`;
    html += '<td class="c">';
    if (r.deleted_at) {
      html += `<button class="btn-mini view" data-act="restore" data-id="${r.id}">Khôi phục</button>`;
      html += `<button class="btn-mini reject" data-act="hard" data-id="${r.id}">Xóa cứng</button>`;
    } else {
      html += `<button class="btn-mini reject" data-act="soft" data-id="${r.id}">Xóa mềm</button>`;
    }
    html += '</td></tr>';
  });
  html += '</tbody></table>';
  wrap.innerHTML = html;

  document.querySelectorAll('#tbl-data button[data-act]').forEach(btn => {
    btn.addEventListener('click', () => adminAction(btn.dataset.act, btn.dataset.id));
  });
}

async function adminAction(act, id) {
  const labels = { soft:'xóa mềm', restore:'khôi phục', hard:'XÓA CỨNG (không thể khôi phục)' };
  if (!confirm(`Xác nhận ${labels[act]} bản ghi này?`)) return;
  try {
    const rpc = { soft:'admin_soft_delete', restore:'admin_restore', hard:'admin_hard_delete' }[act];
    const { error } = await supabase.rpc(rpc, { p_table: _state.currentTable, p_id: id });
    if (error) throw error;
    toast('Thành công', 'ok');
    loadTableData();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

// ═══════════════ TAB 2: USERS ═══════════════
const ROLES = ['viewer','data_entry','approver_l1','approver_l2','approver','bod','admin'];
const ROLE_LABELS = {
  viewer: '👁 Viewer (chỉ xem)',
  data_entry: '✏️ Data Entry (nhập liệu)',
  approver_l1: '✓ Approver L1 (duyệt cấp 1)',
  approver_l2: '✓✓ Approver L2 (duyệt cấp 2)',
  approver: '⚡ Approver (cả L1+L2)',
  bod: '🏢 BOD (Ban Lãnh Đạo)',
  admin: '👑 Admin (full quyền)'
};

async function renderUsersTab() {
  const content = document.getElementById('ad-content');
  content.innerHTML = `
    <div class="ad-toolbar">
      <button class="btn btn-primary btn-sm" id="btn-new-user">+ Tạo user mới</button>
      <button class="btn btn-ghost btn-sm" id="btn-refresh-users">⟳ Refresh</button>
      <span class="muted small" style="margin-left:auto">Tổng: <span id="user-count">—</span> user</span>
    </div>
    <div id="users-data" class="crud-table-wrap"><div class="loading">Đang tải…</div></div>`;
  document.getElementById('btn-new-user').addEventListener('click', openCreateUserModal);
  document.getElementById('btn-refresh-users').addEventListener('click', renderUsersTab);
  await loadUsers();
}

async function loadUsers() {
  try {
    const { data, error } = await supabase.rpc('admin_list_users');
    if (error) throw error;
    renderUsersTable(data || []);
  } catch (e) {
    document.getElementById('users-data').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

function renderUsersTable(users) {
  document.getElementById('user-count').textContent = users.length;
  let html = '<table class="tbl"><thead><tr><th>Email</th><th>Họ tên</th><th>Role</th><th>Phòng ban</th><th class="c">Trạng thái</th><th>Ngày tạo</th><th class="c">Thao tác</th></tr></thead><tbody>';
  users.forEach(u => {
    const roleColor = u.role === 'admin' ? '#A32D2D' 
                    : u.role === 'bod' ? '#7B5BA6' 
                    : u.role.startsWith('approver') ? '#185FA5' 
                    : '#666';
    const roleDisplay = ROLE_LABELS[u.role] || u.role;
    html += `<tr${!u.is_active ? ' style="opacity:0.5"' : ''}>
      <td><b>${escH(u.email)}</b></td>
      <td>${escH(u.full_name || '')}</td>
      <td><span style="color:${roleColor};font-weight:600" title="${escH(u.role)}">${escH(roleDisplay)}</span></td>
      <td class="small">${escH(u.department || '')}</td>
      <td class="c">${u.is_active ? '<span class="badge-st badge-approved">Active</span>' : '<span class="badge-st badge-rejected">Disabled</span>'}</td>
      <td class="small">${fmtDate(u.created_at)}</td>
      <td class="c">
        <button class="btn-mini view" data-act="edit-user" data-id="${u.id}" data-role="${u.role}" data-active="${u.is_active?1:0}" data-email="${escH(u.email)}" data-name="${escH(u.full_name||'')}" data-phone="${escH(u.phone||'')}" data-department="${escH(u.department||'')}">Sửa</button>
        <button class="btn-mini" data-act="reset-pw" data-id="${u.id}" data-email="${escH(u.email)}" style="background:#FFF8E1;color:#854F0B;border-color:#FFCC00">🔑 Reset</button>
        ${u.is_active
          ? `<button class="btn-mini reject" data-act="deactivate" data-id="${u.id}" data-email="${escH(u.email)}">Tạm khóa</button>`
          : `<button class="btn-mini approve" data-act="reactivate" data-id="${u.id}" data-email="${escH(u.email)}">Mở lại</button>`}
      </td>
    </tr>`;
  });
  html += '</tbody></table>';
  document.getElementById('users-data').innerHTML = html;

  document.querySelectorAll('#users-data button[data-act]').forEach(btn => {
    const act = btn.dataset.act;
    btn.addEventListener('click', () => {
      if (act === 'edit-user') {
        editUser(btn.dataset.id, btn.dataset.email, btn.dataset.role, btn.dataset.active === '1', btn.dataset.name, btn.dataset.phone, btn.dataset.department);
      } else if (act === 'deactivate') {
        if (confirm(`Tạm khóa user "${btn.dataset.email}"? Họ sẽ không thể đăng nhập.`)) deactivateUser(btn.dataset.id);
      } else if (act === 'reactivate') {
        if (confirm(`Mở lại quyền truy cập cho "${btn.dataset.email}"?`)) reactivateUser(btn.dataset.id);
      } else if (act === 'reset-pw') {
        resetPasswordModal(btn.dataset.id, btn.dataset.email);
      }
    });
  });
}

async function deactivateUser(id) {
  try {
    const { error } = await supabase.rpc('admin_deactivate_user', { p_user_id: id });
    if (error) throw error;
    toast('Đã tạm khóa', 'ok');
    loadUsers();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

async function reactivateUser(id) {
  try {
    const { error } = await supabase.rpc('admin_reactivate_user', { p_user_id: id });
    if (error) throw error;
    toast('Đã mở lại', 'ok');
    loadUsers();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

// ═══════════════ v28e: RESET PASSWORD ═══════════════
function resetPasswordModal(userId, userEmail) {
  const modal = document.createElement('div');
  modal.className = 'modal-overlay';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center';
  modal.innerHTML = `
    <div class="modal-box" style="background:#fff;border-radius:8px;width:480px;max-width:92vw;box-shadow:0 8px 32px rgba(0,0,0,0.3)">
      <div class="m-hd" style="padding:14px 18px;border-bottom:1px solid #e2e4ee;display:flex;justify-content:space-between;align-items:center">
        <h3 style="margin:0;font-size:15px">🔑 Reset password</h3>
        <button class="m-close" id="rp-close" style="background:transparent;border:0;font-size:22px;cursor:pointer">×</button>
      </div>
      <div class="m-body" style="padding:18px">
        <div style="margin-bottom:14px;padding:8px 12px;background:#f0f0fa;border-radius:4px;font-size:13px">
          <b>User:</b> ${escH(userEmail)}
        </div>
        <div style="margin-bottom:12px">
          <label style="display:flex;align-items:center;gap:8px;cursor:pointer;padding:8px 10px;border:1px solid #e2e4ee;border-radius:4px;margin-bottom:6px">
            <input type="radio" name="rp-mode" value="auto" checked id="rp-auto">
            <div>
              <div style="font-weight:600;font-size:13px">🎲 Tự động generate (recommend)</div>
              <div style="font-size:11px;color:#666">12 ký tự ngẫu nhiên, an toàn</div>
            </div>
          </label>
          <label style="display:flex;align-items:flex-start;gap:8px;cursor:pointer;padding:8px 10px;border:1px solid #e2e4ee;border-radius:4px">
            <input type="radio" name="rp-mode" value="manual" id="rp-manual" style="margin-top:3px">
            <div style="flex:1">
              <div style="font-weight:600;font-size:13px">✏️ Tự nhập password mới</div>
              <input type="text" class="inp" id="rp-manual-input" placeholder="Tối thiểu 6 ký tự" disabled style="margin-top:6px;width:100%">
            </div>
          </label>
        </div>
        <div class="alert" style="background:#FFF8E1;border:1px solid #FFCC00;border-radius:4px;padding:8px 12px;font-size:12px;color:#854F0B">
          <b>⚠ Lưu ý:</b> Password mới chỉ hiển thị 1 LẦN sau khi reset. Hãy copy + gửi cho user ngay.
        </div>
        <div class="modal-actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:18px">
          <button type="button" class="btn btn-ghost" id="rp-cancel">Hủy</button>
          <button type="button" class="btn btn-primary" id="rp-submit" style="background:#854F0B;color:#fff;border-color:#854F0B">Reset password</button>
        </div>
      </div>
    </div>`;
  document.body.appendChild(modal);

  const close = () => modal.remove();
  modal.querySelector('#rp-close').addEventListener('click', close);
  modal.querySelector('#rp-cancel').addEventListener('click', close);
  modal.addEventListener('click', e => { if (e.target === modal) close(); });

  // Toggle manual input
  const manualInput = modal.querySelector('#rp-manual-input');
  modal.querySelectorAll('input[name="rp-mode"]').forEach(radio => {
    radio.addEventListener('change', () => {
      manualInput.disabled = (radio.value !== 'manual' || !radio.checked);
      if (radio.value === 'manual' && radio.checked) manualInput.focus();
    });
  });
  manualInput.addEventListener('focus', () => {
    modal.querySelector('#rp-manual').checked = true;
    manualInput.disabled = false;
  });

  // Submit
  modal.querySelector('#rp-submit').addEventListener('click', async () => {
    const mode = modal.querySelector('input[name="rp-mode"]:checked').value;
    let newPassword = null;
    if (mode === 'manual') {
      newPassword = manualInput.value.trim();
      if (newPassword.length < 6) {
        toast('Password phải tối thiểu 6 ký tự', 'err');
        manualInput.focus();
        return;
      }
    }

    const btn = modal.querySelector('#rp-submit');
    btn.disabled = true;
    btn.textContent = 'Đang reset...';

    try {
      const { data, error } = await supabase.rpc('admin_reset_password', {
        p_user_id: userId,
        p_new_password: newPassword
      });
      if (error) throw error;
      if (!data?.ok) {
        let msg = data?.error || 'Unknown error';
        if (msg === 'PERMISSION_DENIED') msg = 'Bạn không có quyền reset password';
        else if (msg === 'USER_NOT_FOUND') msg = 'Không tìm thấy user';
        else if (msg === 'PASSWORD_TOO_SHORT') msg = 'Password phải tối thiểu 6 ký tự';
        throw new Error(msg);
      }
      close();
      showPasswordResultModal(userEmail, data.password, data.auto_generated);
    } catch (e) {
      toast('Lỗi: ' + e.message, 'err');
      btn.disabled = false;
      btn.textContent = 'Reset password';
    }
  });

  setTimeout(() => modal.querySelector('#rp-auto').focus(), 50);
}

function showPasswordResultModal(userEmail, password, autoGenerated) {
  const modal = document.createElement('div');
  modal.className = 'modal-overlay';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:9999;display:flex;align-items:center;justify-content:center';
  modal.innerHTML = `
    <div class="modal-box" style="background:#fff;border-radius:8px;width:520px;max-width:92vw;box-shadow:0 8px 32px rgba(0,0,0,0.4);border:2px solid #FFCC00">
      <div class="m-hd" style="padding:14px 18px;border-bottom:1px solid #e2e4ee;background:#FFF8E1">
        <h3 style="margin:0;font-size:15px;color:#854F0B">✅ Reset thành công</h3>
      </div>
      <div class="m-body" style="padding:18px">
        <div style="margin-bottom:10px;font-size:13px">
          Password ${autoGenerated ? 'mới (auto-generated)' : 'mới'} của <b>${escH(userEmail)}</b>:
        </div>
        <div style="display:flex;gap:8px;align-items:center;margin-bottom:14px">
          <input type="text" id="show-pw" value="${escH(password)}" readonly
                 style="flex:1;font-family:'Courier New',monospace;font-size:18px;font-weight:bold;text-align:center;padding:10px;border:2px solid #FFCC00;border-radius:4px;background:#FFFEF5;color:#854F0B">
          <button class="btn btn-primary" id="copy-pw" style="background:#854F0B;color:#fff;border-color:#854F0B;white-space:nowrap;padding:10px 14px">📋 Copy</button>
        </div>
        <div class="alert" style="background:#FEF0F0;border:1px solid #E57373;border-radius:4px;padding:10px 12px;font-size:12px;color:#A8000A;line-height:1.5">
          <b>⚠ ĐÂY LÀ LẦN DUY NHẤT password hiển thị.</b><br>
          Đóng popup → password biến mất vĩnh viễn. Hãy copy ngay rồi gửi cho user qua kênh an toàn (email/Zalo).
        </div>
        <div style="margin-top:14px;padding:8px 10px;background:#f0f0fa;border-radius:4px;font-size:11px;color:#666">
          User dùng password này login lần đầu, sau đó nên tự đổi password ngay tại trang Profile.
        </div>
        <div class="modal-actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:14px">
          <button type="button" class="btn btn-primary" id="pr-confirm" style="background:#1B5E20;color:#fff;border-color:#1B5E20">Tôi đã copy & lưu</button>
        </div>
      </div>
    </div>`;
  document.body.appendChild(modal);

  const pwInput = modal.querySelector('#show-pw');
  modal.querySelector('#copy-pw').addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(password);
      toast('✓ Đã copy password vào clipboard', 'ok');
      const btn = modal.querySelector('#copy-pw');
      btn.textContent = '✓ Copied';
      setTimeout(() => { btn.textContent = '📋 Copy'; }, 2000);
    } catch (e) {
      // Fallback: select text
      pwInput.select();
      pwInput.setSelectionRange(0, 99999);
      try {
        document.execCommand('copy');
        toast('✓ Đã copy password', 'ok');
      } catch (_) {
        toast('Không copy được, hãy bôi đen + Ctrl+C', 'err');
      }
    }
  });

  modal.querySelector('#pr-confirm').addEventListener('click', () => modal.remove());
  // KHÔNG cho phép đóng bằng click outside để tránh accidentally close
  // KHÔNG cho phép Escape key

  // Auto-select password để dễ copy
  setTimeout(() => { pwInput.select(); }, 100);
}

function openCreateUserModal() {
  const modal = document.createElement('div');
  modal.className = 'modal-overlay';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center';
  modal.innerHTML = `
    <div class="modal-box" style="background:#fff;border-radius:8px;width:540px;max-width:92vw;max-height:92vh;overflow:auto;box-shadow:0 8px 32px rgba(0,0,0,0.3)">
      <div class="m-hd" style="padding:14px 18px;border-bottom:1px solid #e2e4ee;display:flex;justify-content:space-between;align-items:center">
        <div class="m-title" style="font-size:16px;font-weight:700;color:#000066">+ Tạo user mới</div>
        <button class="m-close" id="cu-close" style="background:transparent;border:0;font-size:22px;cursor:pointer">×</button>
      </div>
      <div class="m-body" style="padding:18px">
        <form id="create-user-form">
          <label class="field"><span>Email <span style="color:#A32D2D">*</span></span>
            <input type="email" name="email" class="inp" required placeholder="user@vinaenc.com.vn" autocomplete="off">
          </label>
          <label class="field"><span>Mật khẩu <span style="color:#A32D2D">*</span></span>
            <div style="display:flex;align-items:center;gap:10px;margin-bottom:6px;padding:6px 10px;background:#FFF8E1;border:1px solid #FFCC00;border-radius:4px">
              <input type="checkbox" id="cu-autogen" checked style="margin:0">
              <label for="cu-autogen" style="font-size:12px;color:#854F0B;cursor:pointer;flex:1">
                <b>🎲 Tự động generate</b> (12 ký tự ngẫu nhiên, recommend)
              </label>
            </div>
            <input type="text" name="password" class="inp" id="cu-password" minlength="6" placeholder="Auto-generated khi tạo" autocomplete="off" disabled>
            <small class="muted">Bỏ check ở trên để tự nhập password</small>
          </label>
          <label class="field"><span>Họ tên <span style="color:#A32D2D">*</span></span>
            <input type="text" name="full_name" class="inp" required placeholder="VD: Nguyễn Văn A">
          </label>
          <label class="field"><span>Vai trò <span style="color:#A32D2D">*</span></span>
            <select name="role" class="inp" required>
              ${ROLES.map(r => `<option value="${r}"${r==='data_entry'?' selected':''}>${ROLE_LABELS[r]}</option>`).join('')}
            </select>
          </label>
          <div class="fg">
            <label class="field"><span>Phòng ban</span>
              <input type="text" name="department" class="inp" placeholder="VD: Ban KSNB">
            </label>
            <label class="field"><span>SĐT</span>
              <input type="tel" name="phone" class="inp" placeholder="VD: 0901234567">
            </label>
          </div>
          <div class="alert" style="background:#FFF8E1;border:1px solid #FFCC00;border-radius:4px;padding:8px 12px;font-size:12px;color:#854F0B;margin-top:10px">
            <b>⚠ Lưu ý:</b> Email phải duy nhất. Sau khi tạo, user có thể đăng nhập ngay với email + password trên (không cần verify email).
          </div>
          <div class="modal-actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:18px">
            <button type="button" class="btn btn-ghost" id="cu-cancel">Hủy</button>
            <button type="submit" class="btn btn-primary" id="cu-save">Tạo user</button>
          </div>
        </form>
      </div>
    </div>`;
  document.body.appendChild(modal);

  const close = () => modal.remove();
  modal.querySelector('#cu-close').addEventListener('click', close);
  modal.querySelector('#cu-cancel').addEventListener('click', close);
  modal.addEventListener('click', e => { if (e.target === modal) close(); });

  // v28e: Toggle auto-gen checkbox
  const autoGenCb = modal.querySelector('#cu-autogen');
  const pwInput = modal.querySelector('#cu-password');
  autoGenCb.addEventListener('change', () => {
    pwInput.disabled = autoGenCb.checked;
    pwInput.required = !autoGenCb.checked;
    if (!autoGenCb.checked) {
      pwInput.placeholder = 'Tối thiểu 6 ký tự';
      pwInput.focus();
    } else {
      pwInput.value = '';
      pwInput.placeholder = 'Auto-generated khi tạo';
    }
  });

  modal.querySelector('#create-user-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const useAutoGen = autoGenCb.checked;
    
    // v28e: Generate password client-side nếu auto-gen
    // (Backend cũng có gen, nhưng client-side để hiển thị popup ngay)
    let password = fd.get('password');
    if (useAutoGen) {
      password = generateClientPassword(12);
    } else if (!password || password.length < 6) {
      toast('Password tự nhập phải tối thiểu 6 ký tự', 'err');
      return;
    }
    
    const payload = {
      email: fd.get('email').trim().toLowerCase(),
      password: password,
      full_name: fd.get('full_name').trim(),
      role: fd.get('role'),
      department: fd.get('department').trim() || null,
      phone: fd.get('phone').trim() || null,
    };

    const btn = modal.querySelector('#cu-save');
    btn.disabled = true;
    btn.textContent = 'Đang tạo...';

    try {
      const { data, error } = await supabase.rpc('admin_create_user', {
        p_email: payload.email,
        p_password: payload.password,
        p_full_name: payload.full_name,
        p_role: payload.role,
        p_phone: payload.phone,
        p_department: payload.department,
      });
      if (error) throw error;
      if (!data?.ok) throw new Error(data?.error || 'Unknown error');

      toast(`✓ Đã tạo user: ${payload.email}`, 'ok');
      close();
      // v28e: Show password popup 1 lần để admin copy
      showPasswordResultModal(payload.email, password, useAutoGen);
      loadUsers();
    } catch (e) {
      let msg = e.message || String(e);
      if (msg.includes('EMAIL_EXISTS')) msg = 'Email đã tồn tại trong hệ thống';
      else if (msg.includes('PASSWORD_TOO_SHORT')) msg = 'Mật khẩu phải có ít nhất 6 ký tự';
      else if (msg.includes('INVALID_EMAIL_FORMAT')) msg = 'Email không hợp lệ';
      else if (msg.includes('INVALID_ROLE')) msg = 'Vai trò không hợp lệ';
      else if (msg.includes('PERMISSION_DENIED')) msg = 'Bạn không có quyền tạo user';
      toast('Lỗi: ' + msg, 'err');
      btn.disabled = false;
      btn.textContent = 'Tạo user';
    }
  });

  setTimeout(() => modal.querySelector('input[name="email"]').focus(), 50);
}

function editUser(id, email, currentRole, isActive, currentName, currentPhone, currentDept) {
  const modal = document.createElement('div');
  modal.className = 'modal-overlay';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center';
  modal.innerHTML = `
    <div class="modal-box" style="background:#fff;border-radius:8px;width:480px;max-width:92vw;box-shadow:0 8px 32px rgba(0,0,0,0.3)">
      <div class="m-hd" style="padding:14px 18px;border-bottom:1px solid #e2e4ee;display:flex;justify-content:space-between;align-items:center">
        <div class="m-title" style="font-size:16px;font-weight:700;color:#000066">Sửa user</div>
        <button class="m-close" id="ed-close" style="background:transparent;border:0;font-size:22px;cursor:pointer">×</button>
      </div>
      <div class="m-body" style="padding:18px">
        <div style="margin-bottom:12px;padding:6px 10px;background:#f0f0fa;border-radius:4px;font-size:12px"><b>Email:</b> ${escH(email)} <span class="muted">(không sửa được)</span></div>
        <label class="field"><span>Họ tên</span>
          <input type="text" id="ed-name" class="inp" value="${escH(currentName || '')}">
        </label>
        <label class="field"><span>Vai trò</span>
          <select id="ed-role" class="inp">
            ${ROLES.map(r => `<option value="${r}"${r===currentRole?' selected':''}>${ROLE_LABELS[r]}</option>`).join('')}
          </select>
        </label>
        <div class="fg">
          <label class="field"><span>Phòng ban</span>
            <input type="text" id="ed-department" class="inp" value="${escH(currentDept || '')}">
          </label>
          <label class="field"><span>SĐT</span>
            <input type="tel" id="ed-phone" class="inp" value="${escH(currentPhone || '')}">
          </label>
        </div>
        <label class="field" style="display:flex;align-items:center;gap:8px;margin-top:8px">
          <input type="checkbox" id="ed-active" ${isActive?'checked':''}>
          <span>Active (cho phép đăng nhập)</span>
        </label>
        <div class="modal-actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:18px">
          <button type="button" class="btn btn-ghost" id="ed-cancel">Hủy</button>
          <button type="button" class="btn btn-primary" id="ed-save">Lưu</button>
        </div>
      </div>
    </div>`;
  document.body.appendChild(modal);

  const close = () => modal.remove();
  modal.querySelector('#ed-close').addEventListener('click', close);
  modal.querySelector('#ed-cancel').addEventListener('click', close);
  modal.addEventListener('click', e => { if (e.target === modal) close(); });

  modal.querySelector('#ed-save').addEventListener('click', async () => {
    const newRole = modal.querySelector('#ed-role').value;
    const active = modal.querySelector('#ed-active').checked;
    const fullName = modal.querySelector('#ed-name').value.trim();
    const phone = modal.querySelector('#ed-phone').value.trim();
    const dept = modal.querySelector('#ed-department').value.trim();

    try {
      const { error } = await supabase.rpc('admin_update_user_role', {
        p_user_id: id,
        p_role: newRole,
        p_is_active: active,
        p_full_name: fullName || null,
        p_phone: phone || null,
        p_department: dept || null,
      });
      if (error) throw error;
      toast('Đã cập nhật', 'ok');
      close();
      loadUsers();
    } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
  });
}

// ═══════════════ TAB 3: DANH MỤC ═══════════════
let _dmTable = 'ifrs_rules';

async function renderDanhMucTab() {
  const content = document.getElementById('ad-content');
  content.innerHTML = `
    <div class="ad-toolbar">
      <select class="inp" id="dm-select">${DANH_MUC_TABLES.map(t => `<option value="${t.id}"${_dmTable===t.id?' selected':''}>${t.label}</option>`).join('')}</select>
      <button class="btn btn-primary btn-sm" id="dm-add">+ Thêm mục</button>
    </div>
    <div id="dm-data" class="crud-table-wrap"><div class="loading">Đang tải…</div></div>`;
  document.getElementById('dm-select').addEventListener('change', e => { _dmTable = e.target.value; loadDM(); });
  document.getElementById('dm-add').addEventListener('click', () => addDM());
  loadDM();
}

async function loadDM() {
  const def = DANH_MUC_TABLES.find(t => t.id === _dmTable);
  try {
    const { data, error } = await supabase.from(_dmTable).select('*').order(def.cols[0]).limit(500);
    if (error) throw error;
    renderDMTable(def, data || []);
  } catch (e) {
    document.getElementById('dm-data').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

function renderDMTable(def, rows) {
  if (!rows.length) { document.getElementById('dm-data').innerHTML = '<div class="empty">Trống</div>'; return; }
  let html = '<table class="tbl"><thead><tr>';
  def.cols.forEach(c => html += `<th>${c}</th>`);
  html += '<th class="c">Thao tác</th></tr></thead><tbody>';
  rows.forEach(r => {
    html += '<tr>';
    def.cols.forEach(c => html += `<td>${escH(r[c] ?? '')}</td>`);
    html += `<td class="c">
      <button class="btn-mini view" data-act="edit-dm" data-id="${r.id || r[def.cols[0]]}" data-val='${JSON.stringify(r).replace(/'/g, '&#39;')}'>Sửa</button>
      <button class="btn-mini reject" data-act="del-dm" data-id="${r.id || r[def.cols[0]]}" data-key="${def.cols[0]}" data-val="${escH(r[def.cols[0]])}">Xóa</button>
    </td></tr>`;
  });
  html += '</tbody></table>';
  document.getElementById('dm-data').innerHTML = html;

  document.querySelectorAll('#dm-data button[data-act="edit-dm"]').forEach(btn => {
    btn.addEventListener('click', () => {
      const r = JSON.parse(btn.dataset.val.replace(/&#39;/g, "'"));
      editDM(r);
    });
  });
  document.querySelectorAll('#dm-data button[data-act="del-dm"]').forEach(btn => {
    btn.addEventListener('click', () => delDM(btn.dataset.key, btn.dataset.val));
  });
}

function addDM() {
  const def = DANH_MUC_TABLES.find(t => t.id === _dmTable);
  editDM({}, true);
}

function editDM(row, isNew=false) {
  const def = DANH_MUC_TABLES.find(t => t.id === _dmTable);
  const modal = document.createElement('div');
  modal.className = 'modal-overlay';
  modal.style.display = 'flex';
  modal.innerHTML = `
    <div class="modal-box">
      <div class="m-hd"><div class="m-title">${isNew?'Thêm':'Sửa'} — ${def.label}</div><button class="m-close" id="mc">×</button></div>
      <div class="m-body">
        ${def.cols.map(c => `<label class="field"><span>${c}</span><input class="inp" name="${c}" value="${escH(row[c] || '')}" ${!isNew && c===def.cols[0]?'readonly':''}></label>`).join('')}
        <div class="modal-actions"><button type="button" class="btn btn-ghost" id="cancel">Hủy</button><button type="button" class="btn btn-primary" id="save">Lưu</button></div>
      </div>
    </div>`;
  document.body.appendChild(modal);
  modal.querySelector('#mc').addEventListener('click', () => modal.remove());
  modal.querySelector('#cancel').addEventListener('click', () => modal.remove());
  modal.querySelector('#save').addEventListener('click', async () => {
    const payload = {};
    def.cols.forEach(c => { payload[c] = modal.querySelector(`[name="${c}"]`).value.trim() || null; });
    try {
      if (isNew) {
        const { error } = await supabase.from(_dmTable).insert(payload);
        if (error) throw error;
      } else {
        const keyCol = def.cols[0];
        const keyVal = row[keyCol];
        const { error } = await supabase.from(_dmTable).update(payload).eq(keyCol, keyVal);
        if (error) throw error;
      }
      toast('Đã lưu', 'ok');
      modal.remove();
      loadDM();
    } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
  });
}

async function delDM(keyCol, keyVal) {
  if (!confirm(`Xóa ${keyVal}?`)) return;
  try {
    const { error } = await supabase.from(_dmTable).delete().eq(keyCol, keyVal);
    if (error) throw error;
    toast('Đã xóa', 'ok');
    loadDM();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

function escH(s) { return String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
function fmtDate(s) { if (!s) return ''; try { return new Date(s).toLocaleDateString('vi-VN'); } catch(e) { return s; } }

// v28e: Generate random password client-side (loai bo ky tu de nham)
function generateClientPassword(length = 12) {
  const chars = 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKMNPQRSTUVWXYZ23456789';
  let result = '';
  if (window.crypto && window.crypto.getRandomValues) {
    const arr = new Uint32Array(length);
    window.crypto.getRandomValues(arr);
    for (let i = 0; i < length; i++) result += chars[arr[i] % chars.length];
  } else {
    for (let i = 0; i < length; i++) result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}

function toast(msg, type='ok') {
  const c = document.getElementById('toast-container'); if (!c) { alert(msg); return; }
  const el = document.createElement('div'); el.className = 'toast toast-' + type; el.textContent = msg;
  c.appendChild(el); setTimeout(() => el.remove(), 3500);
}
